package net.bothosting.docs.pages.hosting_in_bot_hosting_net

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initCoin_system_explainedPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("hosting_in_bot_hosting_net/coin_system_explained.md", FrontMatterElement.Builder { addScalar("description", "How to get coins to host your server? Here's a quick guide with all the alternatives you have!"); addScalar("icon", "coins"); }))
}

@Page("/hosting_in_bot_hosting_net/coin-system-explained")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Coin_system_explainedPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("coin-system-explained") }) {
        org.jetbrains.compose.web.dom.Text("Coin System Explained")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Bot-hosting uses a coin system. Servers cost a certain number of coins every week or month, depending on your active server's plans and payment cycle, so you need coins to create your server and keep it running.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("There are 3 ways to get coins:")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("1-free-coins-generator") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("1. Free Coins Generator")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#lxke7kwlzz4");attr("id", "lxke7kwlzz4")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The generator can be found at the top of the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://bot-hosting.net/panel/earn") {
            org.jetbrains.compose.web.dom.Text("Earn Coins page")
        }
        org.jetbrains.compose.web.dom.Text(". You must complete the captcha and then click the button labeled ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Click here to claim one free coin!")
        }
        org.jetbrains.compose.web.dom.Text(". You can claim up to 10 coins per day with this method.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (1).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.H4(attrs = { id("2-affiliate-program") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("2. Affiliate Program")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#i1rpfrwzpes");attr("id", "i1rpfrwzpes")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The affiliate page can be found ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://bot-hosting.net/panel/affiliate") {
            org.jetbrains.compose.web.dom.Text("here")
        }
        org.jetbrains.compose.web.dom.Text(". Invite new users to create an account through your affiliate link. You get ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("10 coins")
        }
        org.jetbrains.compose.web.dom.Text(" when a new user signs up for the first time.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Didn't get coins? See ")
            com.varabyte.kobweb.silk.components.navigation.Link("../faqs_and_info/why-didnt-i_receive_coins_after_inviting_to_register.md") {
                org.jetbrains.compose.web.dom.Text("why-didnt-i-receive-coins-after-inviting-to-register.md")
            }
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("3-buy-coin-packs") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("3. Buy Coin Packs")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#tdx757wa6s8");attr("id", "tdx757wa6s8")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can also buy coins with money. This may be required if your bot needs more resources.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can pay by credit or debit card with Stripe, or with the other payment methods listed in the ")
        com.varabyte.kobweb.silk.components.navigation.Link("/faqs_and_info/payment-guide") {
            org.jetbrains.compose.web.dom.Text("payment-guide.md")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (1) (1).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.H3(attrs = { id("what-s-next") }) {
        org.jetbrains.compose.web.dom.Text("What's next?")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("create-a_server.md") {
            org.jetbrains.compose.web.dom.Text("Create a Server")
        }
        org.jetbrains.compose.web.dom.Text(" - Create your first server.")
    }
}
